
import {map} from 'rxjs/operators';
 import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { Baseservice } from './baseservice';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DocumenttypeService  extends Baseservice{

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('documenttype', http, authentication);
   }
   getByType(type: string) {
    return this.getRequest(this.url + '/bytype/' + type);
}

getLinkedAndUnlinkedDoctypes(invCatId: number) {
    return this.getRequest(this.url + '/links/' + invCatId);
}
getRCPDocsTypes(){
    return this.getRequest(this.url + '/rcp');
}
getDriverDocsTypes(){
    return this.getRequest(this.url + '/driver');
}
addToLinks(body: any) {

return this.http.post(this.url + '/links/', body);
}

deleteLink(id: number) {
    return this.http.delete(this.url + '/links/' + id);
}

updateLink(body: any) {

   return this.http.put(this.url + '/links/', body);
}

getLinkById(id: number) {
    return this.getRequest(this.url + `/links/find/${id}`);
}
getDocTypeLinkByCarrierTypeId(id: number) {
    return this.getRequest(this.url + `/links/type/${id}`);
}
getDocTypeLinkByPermitTypeId(id: number) {
    return this.getRequest(this.url + `/links/permit-type/${id}`);
}
getAllFixed(page, pageSize) {
    return this.getRequest(this.url + '/' + page + '/' + pageSize);
}
}
